import { render, staticRenderFns } from "./ImportCSV.vue?vue&type=template&id=60eb8c63&scoped=true"
import script from "./ImportCSV.vue?vue&type=script&lang=js"
export * from "./ImportCSV.vue?vue&type=script&lang=js"
import style0 from "./ImportCSV.vue?vue&type=style&index=0&id=60eb8c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eb8c63",
  null
  
)

export default component.exports